module.exports = __webpack_public_path__ + "img/puptitle2.e0874e87.png";